/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { BaseResponse } from '../../models/base-response';
import { TravelBookingAvailability } from '../../models/travel-booking-availability';

export interface BookingControllerAvailability$Params {
  travel_id: number;
}

export function bookingControllerAvailability(http: HttpClient, rootUrl: string, params: BookingControllerAvailability$Params, context?: HttpContext): Observable<StrictHttpResponse<BaseResponse & {
'data'?: TravelBookingAvailability;
}>> {
  const rb = new RequestBuilder(rootUrl, bookingControllerAvailability.PATH, 'get');
  if (params) {
    rb.path('travel_id', params.travel_id, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<BaseResponse & {
      'data'?: TravelBookingAvailability;
      }>;
    })
  );
}

bookingControllerAvailability.PATH = '/booking/{travel_id}/availability';
